import { Injectable } from '@angular/core';
import {LeftpanelComponent, LoaderWithProgressComponent} from './leftpanel/leftpanel.component';
import {MatDialog} from '@angular/material';
import {KongService} from './kong.service';
import {
  CreateGatewayResourceConfirmationComponent,
  ModeOfAccessConfirmationComponent,
  SecureApiConfirmationComponent
} from './manage-entities/manage-entities.component';
import {ConfService} from './conf.service';

@Injectable({
  providedIn: 'root'
})
export class AccessPolicyService {

  constructor(public platform: LeftpanelComponent,
              private kong: KongService,
              public confPost: ConfService,
              public dialog: MatDialog) { }


  patchPluginInAPIGateway(id, plugin) {
    return new Promise((resolve, reject) => {
      this.kong.patchPluginInApiGateway(id, plugin).subscribe(response => {
        resolve('success');
      }, error => {
        resolve('failed');
      });
    });
  }

  togglePublicAccess(partner, account, entity, version, resp) {
    return new Promise((resolve, reject) => {
      this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(gatewayService => {
        if (gatewayService) {
          this.kong.getPluginsForServiceByPluginNameInApiGateway(gatewayService['name'], 'ip-restriction').subscribe(plugin => {
            if (plugin) {
              let pluginData = plugin;
              const id = pluginData.id;
              const publishdata = {};
              publishdata['entity'] = entity;
              publishdata['version'] = version;
              publishdata['scopeOfAccess'] = resp['scopeOfAccess'];
              publishdata['published'] = resp['published'];
              publishdata['pluginData'] = pluginData;
              const dialogRef = this.dialog.open(SecureApiConfirmationComponent, {
                width: '60%',
                data: publishdata
              });
              dialogRef.afterClosed().subscribe(async result => {
                if (result === 'unsecure') {
                  // Disable IP Restriction Plugin
                  pluginData = publishdata['pluginData'];
                  pluginData.enabled = false;

                  await this.patchPluginInAPIGateway(id, pluginData);
                  this.kong.getRoutesForAServiceFromApiGateway(gatewayService['id']).subscribe(routeResp => {
                    if (routeResp) {
                      let gatewayRoute: any;
                      gatewayRoute = routeResp;
                      for (const route of gatewayRoute['data']) {
                        if (route) {
                          this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                            if (routePlugin) {
                              const pluginData1 = routePlugin;
                              const id1 = pluginData1.id;
                              pluginData1.enabled = false;
                              await this.patchPluginInAPIGateway(id1, pluginData1);
                            }
                          });
                        }
                      }
                    }
                    resp['scopeOfAccess'] = 'public';
                    resp['lastModifiedTime'] = Date.now();
                    this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                      this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                      this.platform.refreshExecutors();
                      // this.platform.openSnackBar('API has been provided the public access successfully.', 'Success', {
                      //   duration: 5000,
                      //   verticalPosition: 'top',
                      //   horizontalPosition: 'center'
                      // });
                      resolve('success');
                    }, updateError => {
                      pluginData.enabled = true;
                      this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                        reject(updateError);
                        // this.platform.handleErrorGracefully(updateError, 'Error while providing public access to your API. Please try again after sometime');
                      });
                    });
                  }, error => {
                    reject(error);
                  });
                } else if (result === 'secure') {
                  // Enable IP Restriction Plugin
                  pluginData = publishdata['pluginData'];
                  pluginData.enabled = true;

                  await this.patchPluginInAPIGateway(id, pluginData);
                  this.kong.getRoutesForAServiceFromApiGateway(gatewayService['id']).subscribe(routeResp => {
                    if (routeResp) {
                      let gatewayRoute: any;
                      gatewayRoute = routeResp;
                      for (const route of gatewayRoute['data']) {
                        if (route) {
                          this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                            if (routePlugin) {
                              const pluginData1 = routePlugin;
                              const id1 = pluginData1.id;
                              pluginData1.enabled = true;
                              await this.patchPluginInAPIGateway(id1, pluginData1);
                            }
                          });
                        }
                      }
                    }
                    resp['scopeOfAccess'] = 'private';
                    resp['lastModifiedTime'] = Date.now();
                    this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                      this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                      this.platform.refreshExecutors();
                      // this.platform.openSnackBar('API has been restricted for public access successfully.', 'Success', {
                      //   duration: 5000,
                      //   verticalPosition: 'top',
                      //   horizontalPosition: 'center'
                      // });
                      resolve('success');
                    }, updateError => {
                      pluginData.enabled = false;
                      this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                        reject(updateError);
                        // this.platform.handleErrorGracefully(updateError, 'Error while restricting the public access for your API. Please try again after sometime');
                      });
                    });
                  }, error => {
                    reject(error);
                  });
                } else {
                  resolve('cancel');
                }
              });
            } else {
              // NO PLUGIN
              // event.source.checked = !event.source.checked;
              Promise.resolve(this.configureIPRestrictionAndMakeItPublic(partner, account, entity, version, resp)).then(response => {
                  resolve(response);
              }, error => {
                reject(error);
              });
            }
          });
        } else {
          const dialogRef1 = this.dialog.open(CreateGatewayResourceConfirmationComponent, {
            width: '60%',
            height: 'auto',
            data: {
              entity: entity,
              version: version
            }
          });
          dialogRef1.afterClosed().subscribe(result => {
            if (result !== 'cancel') {
              Promise.resolve(this.configureDefaultGatewaySettings(partner, account, entity, version, resp, result)).then(response => {
                resolve(response);
              }, error => {
                reject(error);
              });
            } else {
              resolve(result);
            }
          });
        }
      }, error => {
        if (error.status === 404) {
          const dialogRef1 = this.dialog.open(CreateGatewayResourceConfirmationComponent, {
            width: '60%',
            height: 'auto',
            data: {
              entity: entity,
              version: version
            }
          });
          dialogRef1.afterClosed().subscribe(result => {
            if (result !== 'cancel') {
              Promise.resolve(this.configureDefaultGatewaySettings(partner, account, entity, version, resp, result)).then(response => {
                resolve(response);
              }, error1 => {
                reject(error1);
              });
            } else {
              resolve(result);
            }
          });
        }
      });
    });
  }

  configureIPRestrictionAndMakeItPublic(partner, account, entity, version, resp) {

    return new Promise((resolve, reject) => {
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        width: 'auto',
        height: 'auto',
      });

      this.kong.getDefaultPlugins();
      this.kong.createPluginForServiceInGateway({name: partner + '-' + account + '-' + entity + '-' + version}, this.kong.ipRestriction, {}).then(serviceResp => {
        this.kong.getRoutesForAServiceFromApiGateway(partner + '-' + account + '-' + entity + '-' + version).subscribe(async routeResp => {
          if (routeResp) {
            let gatewayRoute: any;
            gatewayRoute = routeResp;
            for (const route of gatewayRoute['data']) {
              if (route) {
                await this.kong.createPluginForRouteInGateway({name: route['name']}, this.kong.ipRestriction, {}).then(routePluginResp => {

                }, error => {
                  if (error.status === 409) {
                    this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async plugin => {
                      if (plugin) {
                        const pluginData = plugin;
                        const id = pluginData.id;
                        pluginData.enabled = false;
                        await this.patchPluginInAPIGateway(id, pluginData);
                      }
                    });
                  }
                });
              }
            }
          }
          // loaderDialog.close();
          resp['scopeOfAccess'] = 'public';
          resp['published'] = true;
          const methods1 = [];
          if (resp && resp['methods']) {
            for (const method of resp['methods']) {
              if (method !== 'OPTIONS') {
                methods1.push(method);
              }
            }
            resp['methods'] = methods1;
          }
          resp['lastModifiedTime'] = Date.now();
          this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
            this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
            this.platform.refreshExecutors();
            // this.platform.openSnackBar('API has been successfully configured with IP Restriction setting and made publicly accessible.', 'Success', {
            //   duration: 5000,
            //   verticalPosition: 'top',
            //   horizontalPosition: 'center'
            // });
            loaderDialog.close();
            resolve('success');
          }, error => {
            loaderDialog.close();
            reject(error);
          });
        }, error => {
          loaderDialog.close();
          reject(error);
        });
      }, error => {
        loaderDialog.close();
        reject(error);
      });
    });
  }

  configureDefaultGatewaySettings(partner, account, entity, version, resp, result) {

    return new Promise((resolve, reject) => {
      const logTimeStamp = Date.now();
      if (result === 'configure') {
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
          width: 'auto',
          height: 'auto',
          data: {
            message: ''
          }
        });
        this.kong.configureApiGatewayWithIpRestrictionWithMethods(partner, account, entity, version, false, true, [resp['executor_method_type']], logTimeStamp, '').then(response => {
          const methods = [];
          if (resp && resp['methods']) {
            for (const method of resp['methods']) {
              if (method !== 'OPTIONS') {
                methods.push(method);
              }
            }
            resp['methods'] = methods;
          }
          resp['published'] = true;
          resp['scopeOfAccess'] = 'public';
          resp['lastModifiedTime'] = Date.now();
          this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updResp => {
            loaderDialog.close();
            const dialogRef2 = this.dialog.open(ModeOfAccessConfirmationComponent, {
              width: '60%',
              height: 'auto',
              disableClose: true
            });
            dialogRef2.afterClosed().subscribe(result1 => {
              if (result1 === 'public') {
                resp['scopeOfAccess'] = 'public';
                resp['published'] = true;
                resp['lastModifiedTime'] = Date.now();
                this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                  this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                  this.platform.refreshExecutors();
                  // this.platform.openSnackBar('API has been provided the public access successfully.', 'Success', {
                  //   duration: 5000,
                  //   verticalPosition: 'top',
                  //   horizontalPosition: 'center'
                  // });
                  resolve('success');
                }, error => {
                  reject(error);
                });
              } else if (result1 === 'private') {
                this.kong.getServicesFromApiGatewayByNameOrId(partner + '-' + account + '-' + entity + '-' + version).subscribe(gatewayService1 => {
                  if (gatewayService1) {
                    this.kong.getPluginsForServiceByPluginNameInApiGateway(gatewayService1['name'], 'ip-restriction').subscribe(async plugin => {
                      if (plugin) {
                        const pluginData = plugin;
                        const id = pluginData.id;
                        pluginData.enabled = true;

                        await this.patchPluginInAPIGateway(id, pluginData);
                        this.kong.getRoutesForAServiceFromApiGateway(gatewayService1['id']).subscribe(routeResp => {
                          if (routeResp) {
                            let gatewayRoute: any;
                            gatewayRoute = routeResp;
                            for (const route of gatewayRoute['data']) {
                              if (route) {
                                this.kong.getPluginsForRouteByPluginNameInApiGateway(route['name'], 'ip-restriction').subscribe(async routePlugin => {
                                  if (routePlugin) {
                                    const pluginData1 = routePlugin;
                                    const id1 = pluginData1.id;
                                    pluginData1.enabled = true;
                                    await this.patchPluginInAPIGateway(id1, pluginData1);
                                  }
                                });
                              }
                            }
                          }
                          resp['scopeOfAccess'] = 'private';
                          resp['published'] = true;
                          resp['lastModifiedTime'] = Date.now();
                          this.confPost.updateApiExecutorForPartnerAccount(partner, account, resp['id'], resp).subscribe(updateResp => {
                            this.platform.updateAPIAuditLog(partner, account, resp['executor_name'], resp['executor_version'], resp['executor_type'], resp, resp);
                            this.platform.refreshExecutors();
                            // this.platform.openSnackBar('API has been restricted for public access successfully.', 'Success', {
                            //   duration: 5000,
                            //   verticalPosition: 'top',
                            //   horizontalPosition: 'center'
                            // });
                            resolve('success');
                          }, updateError => {
                            pluginData.enabled = false;
                            this.kong.updatePluginInApiGateway(id, pluginData).subscribe(response => {
                              reject(updateError);
                              // this.platform.handleErrorGracefully(updateError, 'Error while restricting the public access for your API. Please try again after sometime');
                            });
                          });
                        }, error => {
                          reject();
                        });
                      } else {
                        reject();
                      }
                    });
                  } else {
                    reject();
                  }
                });
              } else {
                resolve('cancel');
              }
            });
          }, error => {
            loaderDialog.close();
            reject(error);
          });
        }, error => {
          loaderDialog.close();
          reject(error);
          // this.platform.openSnackBar('Error while configuring gateway settings for your API. Please try again after sometime', 'Error', {
          //   duration: 5000,
          //   verticalPosition: 'top',
          //   horizontalPosition: 'center'
          // });
        });
      } else {
        reject({'message': 'Gateway settings has to be configured to set the API Access policy'});
      }
    });
  }
}
